import { Link as GatsbyLink } from "gatsby";
import styled from "styled-components";

import { aStyles } from "./styles";

export const Link = styled(GatsbyLink)([""], aStyles);
